import React, { useEffect, useState } from "react";
import api, { img } from "../../lib/api";
import { AdminHeader } from "./AdminLayout";
import { toast } from "sonner";
import { Plus, X, Upload } from "lucide-react";

export default function AdminJournal() {
  const [posts, setPosts] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/journal").then(r => setPosts(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (edit.id) await api.put(`/admin/journal/${edit.id}`, edit); else await api.post("/admin/journal", edit);
    toast.success("Saved"); setEdit(null); load();
  };
  const del = async (p) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/journal/${p.id}`); load(); };
  const uploadImg = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    const r = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    setEdit({ ...edit, cover: r.data.url });
  };
  return (
    <div>
      <AdminHeader title="Journal" action={<button onClick={() => setEdit({ title: "", slug: "", category: "Nature", author: "IAH Editorial", excerpt: "", body: "", cover: "", published: true })} className="btn-primary flex items-center gap-2"><Plus size={15} /> New Article</button>} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {posts.map((p) => (
          <div key={p.id} className="bg-white border border-sage/30 rounded-sm overflow-hidden">
            <img src={img(p.cover)} alt="" className="h-32 w-full object-cover" />
            <div className="p-4"><div className="text-xs text-moss uppercase">{p.category}</div><div className="serif text-xl mb-2">{p.title}</div>
              <div className="flex gap-2"><button onClick={() => api.get(`/journal/${p.slug}`).then(r => setEdit(r.data))} className="text-xs underline">Edit</button><button onClick={() => del(p)} className="text-xs underline text-brown">Delete</button></div></div>
          </div>
        ))}
      </div>
      {edit && (
        <div className="fixed inset-0 z-[80]"><div className="absolute inset-0 bg-forest/40" onClick={() => setEdit(null)} />
          <div className="absolute right-0 top-0 bottom-0 w-full max-w-2xl bg-ivory p-6 overflow-auto">
            <div className="flex justify-between mb-6"><h2 className="serif text-3xl">Article</h2><button onClick={() => setEdit(null)}><X size={22} /></button></div>
            <div className="space-y-4">
              <I label="Title" v={edit.title} on={(v) => setEdit({ ...edit, title: v })} />
              <div className="grid grid-cols-3 gap-4"><I label="Slug" v={edit.slug} on={(v) => setEdit({ ...edit, slug: v })} /><I label="Category" v={edit.category} on={(v) => setEdit({ ...edit, category: v })} /><I label="Author" v={edit.author} on={(v) => setEdit({ ...edit, author: v })} /></div>
              <I label="Excerpt" v={edit.excerpt} on={(v) => setEdit({ ...edit, excerpt: v })} />
              <div><label className="text-xs uppercase text-forest/55">Body (paragraphs separated by blank line)</label><textarea className="w-full border border-sage/40 px-3 py-2 mt-1 rounded-sm" rows={8} value={edit.body} onChange={(e) => setEdit({ ...edit, body: e.target.value })} /></div>
              <div className="flex items-center gap-3">{edit.cover && <img src={img(edit.cover)} alt="" className="h-16 w-24 object-cover" />}<label className="btn-outline cursor-pointer flex items-center gap-2 text-xs py-2"><Upload size={14} /> Cover<input type="file" accept="image/*" className="hidden" onChange={uploadImg} /></label></div>
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={!!edit.published} onChange={(e) => setEdit({ ...edit, published: e.target.checked })} className="accent-forest" /> Published</label>
              <button onClick={save} className="btn-primary w-full">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
const I = ({ label, v, on }) => <div><label className="text-xs uppercase text-forest/55">{label}</label><input value={v ?? ""} onChange={(e) => on(e.target.value)} className="w-full border border-sage/40 px-3 py-2 mt-1 rounded-sm bg-white text-sm" /></div>;
